import React from "react";
import "./Banner.css";
import { Carousel } from "react-bootstrap";

const Banner = ({ effect }) => {
  const images = [
    "https://estate.deltaservis.com.tr/items/3/images/1.jpg", // Replace with actual image URLs
    "https://estate.deltaservis.com.tr/items/3/images/4.jpg", // Replace with actual image URLs
  ];

  const singleImage =
    "https://estate.deltaservis.com.tr/items/3/images/1.jpg";

  console.log(effect);

  return effect === "parallax" ? (
    <div className="banner-container parallax">
      <div
        className="banner-image"
        style={{ backgroundImage: `url(${singleImage})` }}
      ></div>
    </div>
  ) : (
    <div className="banner-container">
      <Carousel indicators={false} controls={false} interval={3000}>
        {images.map((image, index) => (
          <Carousel.Item key={index}>
            <div
              className="banner-image"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Banner;
